import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoaderMessageDetail = () => {
  return (
    <div className="p-10 divide-y divide-neutrals-200">
      <div className="space-y-3 pt-40 pb-10">
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </div>
      <div className="space-y-3 py-10">
        <Skeleton animation="wave" variant="text" className="mb-10" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton variant="rect" width="full" height={118} />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </div>
      <div className="space-y-3 py-10">
        <Skeleton variant="rect" width="full" height={63} />
      </div>
      <div className="divide-y divide-neutrals-200"></div>
    </div>
  )
}

export default LoaderMessageDetail
